<form (ngSubmit)="onSubmit()" [formGroup]="loginFormGroup" class="flex-column-with-footer flex-column-with-form">
    <ng-content select="[headerContent]"></ng-content>
    <lib-error-card [errors]="submissionError" />
    <lib-input
        [form]="loginFormGroup"
        [ionItemWrap]="false"
        controlName="email"
        label="Email"
        placeholder="Enter email"
        type="email" />

    <lib-input
        [form]="loginFormGroup"
        [ionItemWrap]="false"
        controlName="password"
        label="Password"
        placeholder="Enter your password"
        type="password" />

    <div class="text-right ion-margin-vertical">
        <lib-button [displayAsInlineText]="true" [expand]="false" inlineTextColor="dark" routerLink="/reset-password">
            Forgot password?
        </lib-button>
    </div>
    <div>
        <lib-button type="submit" [disabled]="!loginFormGroup.valid">Log in</lib-button>
        <ng-content select="[footerContent]"></ng-content>
    </div>
</form>
